module.exports = __webpack_public_path__ + "fonts/SF-Pro-Display-Regular.d704bcd6.ttf";